<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!consultas || !consultas.length">
    Não foram encontradas consultas com os filtros informados.
  </div>

  <div class="row" *ngIf="consultas && consultas.length">
    <bn-paginacao [total]="atributosPaginacao.count"
                  [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
                  [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th id="col-nome" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeRazaoSocial'"
                            [nomeAtributoExibicao]="'Nome ou razão social'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
            </th>
            <th id="col-cnpj" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjCpf'"
                            [nomeAtributoExibicao]="'CNPJ'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
            </th>
            <th id="col-dt-consulta" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataConsulta'"
                            [nomeAtributoExibicao]="'Dt. Consulta'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
            </th>
            <th id="col-responsavel" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'responsavel'"
                            [nomeAtributoExibicao]="'Responsável'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
            </th>
            <th id="col-cadin" scope="col" class="text-center">CADIN</th>
            <th id="col-validade" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataValidade'"
                            [nomeAtributoExibicao]="'Data de Validade'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let consulta of consultas">
            <td>{{ consulta.nomeRazaoSocial }}</td>
            <td class="font-monospace">{{ formatarCnpjCpf(consulta.cnpjCpf) }}</td>
            <td>{{ consulta.dataConsulta | date: 'dd/MM/yyyy' }}</td>
            <td>{{ consulta.responsavel }}</td>
            <td class="text-center">
              <ng-container *ngIf="getStatusCadin(consulta) as statusCadin">
                <span class="cadin-bolinha"
                      [ngClass]="statusCadin.cssClass"
                      [ngbTooltip]="statusCadin.tooltip">
                </span>
                </ng-container>
            </td>
            <td>{{ consulta.dataValidade | date: 'dd/MM/yyyy' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>
